// Le systeme de logs interne (collection Firestore "log") a ete supprime :
// il ecrivait un document a chaque appel API et avait depasse 4 millions de
// documents pour aucune valeur metier. Les erreurs sont desormais couvertes
// par Sentry. On garde la fonction en no-op pour ne pas toucher les ~200
// appelants existants.
const addLogDocument = async (..._args) => {
  return "noop";
};

export default addLogDocument;
